import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import history from '../../history';
import UserBadge from '../UserBadge';
import { noBubble } from '../../utils/events';

import styles from './companyLogo.module.scss';

const CompanyLogo = ({
  company,
  setActiveCompany,
  setActiveLocation,
  allLocations,
  setActiveGroups,
  setActiveProject,
  user,
  assignIncidentOwner,
  companyName
}) => {
  const restricted = user.accessLevel < 500;
  const handleLogoClick = () => {
    setActiveCompany(company);
    setActiveLocation(0);
    setActiveGroups(company.groups);
    allLocations(company.allLocations);
    setActiveProject();
    history.push({
      pathname: '/app/dashboard',
      state: {
        showToasts: true,
        showNotificationModal: !user.notifications
      }
    });
  };

  return (
    <div className={styles.companyLogo}>
      {company.logoUrl && (
        <img
          src={company.logoUrl}
          alt={`${company.name}'s Logo`}
          className={
            restricted
              ? styles.companyLogoImageNoAccess
              : styles.companyLogoImage
          }
          onClick={!restricted ? handleLogoClick : null}
        />
      )}
      <div className={styles.companyLogoCompany}>
        <UserBadge
          size="medium"
          userId={company?.defaultIncidentOwner?.userId}
          showImage
          hoverName
          className={
            restricted
              ? styles.companyLogoHoverNoAccess
              : styles.companyLogoHover
          }
          onClick={e => {
            noBubble(e);
            if (!restricted)
              assignIncidentOwner(company.defaultIncidentOwner?.userId ?? '');
          }}
        />
        <div
          className={
            restricted
              ? styles.companyLogoCompanyDivWithoutHover
              : styles.companyLogoCompanyDiv
          }
          onClick={!restricted ? handleLogoClick : null}
          data-tooltip-id={`${company._id}`}
          data-tooltip-class-name="toolTip"
        >
          {companyName}
        </div>
        {!restricted && (
          <div className={styles.companyLogoCompanyDivHover}>
            {company.defaultIncidentOwner ? 'Reassign' : 'Assign'} Incident
            Owner
          </div>
        )}
      </div>
      {restricted && (
        <ReactTooltip id={`${company._id}`} className="tooltip">
          *Permission restricted for lower levels
        </ReactTooltip>
      )}
    </div>
  );
};
export default CompanyLogo;
